module.exports = __webpack_public_path__ + "static/ocorie-abt-5-f4331c41cf5d461eed4162a3d7c17655.png";